export interface Login {
  username: string;
  password: string;
}

export interface UserTermsType {
  id: number;
  text: string;
}

export interface OrganisationType {
  id: number;
  name: string;
  tenantName: string;
}

export interface AuthErrorResponse {
  message: string | '';
  code: number | null;
  UserTerms?: UserTermsType | {};
  Organisations?: OrganisationType | {};
}

export interface Preferences {
  isMarketingUpdatesAllowed: boolean;
  isNewslettersAllowed: boolean;
  timezone?: boolean;
}

export interface TermsAcceptance {
  userTermsId?: number;
  preferences: Preferences;
}

export interface OrganisationTypes {
  id: number;
  name: string;
  tenantName: string;
}
export interface ActionType {
  FETCH_REQUEST: any;
  FETCH_SUCCESS: string;
  AUTH_FAILURE: string;
  ACCEPT_SIGNIN_TERMS: string;
  ACCEPT_SIGNIN_TERMS_SUCCESS: string;
  ACCEPT_SIGNIN_TERMS_FAILURE: string;
  SELECT_SESSION_ORG_ROLE: string;
  SELECT_SESSION_ORG_ROLE_SUCCESS: string;
  SELECT_SESSION_ORG_ROLE_FAILURE: string;
  FETCH_OTP_STATUS: string;
  FETCH_OTP_CODE: string;
  FETCH_OTP_CODE_SUCCESS: string;
  FETCH_OTP_CODE_FAILURE: string;
  SIGN_IN_WITH_OTP_CODE: string;
  SIGN_IN_WITH_OTP_CODE_SUCCESS: string;
  SIGN_IN_WITH_OTP_CODE_FAILURE: string;
  SIGN_IN_WITH_TEMPORARY_CODE: string;
  SIGN_IN_WITH_TEMPORARY_CODE_SUCCESS: string;
  SIGN_IN_WITH_TEMPORARY_CODE_FAILURE: string;
  RESET_ERROR: string;
  SIGN_IN_FOR_EXTERNAL_APP: string;
  SIGN_IN_FOR_EXTERNAL_APP_SUCCESS: string;
  SIGN_IN_FOR_EXTERNAL_APP_FAILURE: string;
}

export const LoginActionTypes: ActionType = {
  FETCH_REQUEST: '@@FETCH_AUTH_REQUEST',
  FETCH_SUCCESS: '@@FETCH_AUTH_SUCCESS',
  AUTH_FAILURE: '@@FETCH_AUTH_FAILURE',
  ACCEPT_SIGNIN_TERMS: '@@ACCEPT_SIGNIN_TERMS',
  ACCEPT_SIGNIN_TERMS_SUCCESS: '@@ACCEPT_SIGNIN_TERMS_SUCCESS',
  ACCEPT_SIGNIN_TERMS_FAILURE: '@@ACCEPT_SIGNIN_TERMS_FAILURE',
  SELECT_SESSION_ORG_ROLE: '@@SELECT_SESSION_ORG_ROLE',
  SELECT_SESSION_ORG_ROLE_SUCCESS: '@@SELECT_SESSION_ORG_ROLE_SUCCESS',
  SELECT_SESSION_ORG_ROLE_FAILURE: '@@SELECT_SESSION_ORG_ROLE_FAILURE',
  FETCH_OTP_STATUS: '@@FETCH_OTP_STATUS',
  FETCH_OTP_CODE: '@@FETCH_OTP_CODE',
  FETCH_OTP_CODE_SUCCESS: '@@FETCH_OTP_CODE_SUCCESS',
  FETCH_OTP_CODE_FAILURE: '@@FETCH_OTP_CODE_FAILURE',
  SIGN_IN_WITH_OTP_CODE: '@@SIGN_IN_WITH_OTP_CODE',
  SIGN_IN_WITH_OTP_CODE_SUCCESS: '@@SIGN_IN_WITH_OTP_CODE_SUCCESS',
  SIGN_IN_WITH_OTP_CODE_FAILURE: '@@SIGN_IN_WITH_OTP_CODE_FAILURE',
  SIGN_IN_WITH_TEMPORARY_CODE: '@@SIGN_IN_WITH_TEMPORARY_CODE',
  SIGN_IN_WITH_TEMPORARY_CODE_SUCCESS: '@@SIGN_IN_WITH_TEMPORARY_CODE_SUCCESS',
  SIGN_IN_WITH_TEMPORARY_CODE_FAILURE: '@@SIGN_IN_WITH_TEMPORARY_CODE_FAILURE',
  RESET_ERROR: '@@RESET_ERROR',
  SIGN_IN_FOR_EXTERNAL_APP: '@@SIGN_IN_FOR_EXTERNAL_APP',
  SIGN_IN_FOR_EXTERNAL_APP_SUCCESS: '@@SIGN_IN_FOR_EXTERNAL_APP_SUCCESS',
  SIGN_IN_FOR_EXTERNAL_APP_FAILURE: '@@SIGN_IN_FOR_EXTERNAL_APP_FAILURE'
};

export interface LoginState {
  submitting: boolean;
  error?: AuthErrorResponse | string;
  data?: any | string;
  isAuthFailed?: boolean;
  isTermsAccepted?: boolean;
  isOTPActivated?: boolean;
  isSingedInWithOTP?: boolean;
  isSingedInWithTemporaryCode?: boolean;
  isSingedInForExternalApp?: boolean;
  email?: any | string;
}
